/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { COUNTERPARTS: de },
  'el-GR': { COUNTERPARTS: el },
  'en-US': { COUNTERPARTS: en },
  'es-ES': { COUNTERPARTS: es },
  'fi-FI': { COUNTERPARTS: fi },
  'fr-FR': { COUNTERPARTS: fr },
  'it-IT': { COUNTERPARTS: it },
  'pl-PL': { COUNTERPARTS: pl },
  'pt-PT': { COUNTERPARTS: pt }
};
